/**
 * File events.js.
 *
 * Handles events list blocks.
 */
(function ($) {
    'use strict';

    $(document).ready(function () {
        // Add the class to the body
        const heights = $(".content-listing__icon-style .content-listing__item .button-block-a__inner-text").map(function() {
            return $(this).outerHeight(true);
        }).get();
        
        const maxHeight = Math.max.apply(null, heights);
        $(".content-listing__icon-style .content-listing__item .button-block-a__inner-text").css("height", maxHeight);
        // Add the class to the body
    });
    $(window).on('resize', function () {
        const heights = $(".content-listing__icon-style .content-listing__item .button-block-a__inner-text").map(function() {
            return $(this).outerHeight(true);
        }).get();
        
        const maxHeight = Math.max.apply(null, heights);
        $(".content-listing__icon-style .content-listing__item .button-block-a__inner-text").css("height", maxHeight);
    });
})(jQuery);